var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { PHASE } from "../routeConfig";
import { clickedCloseButton, confirmCloseShown } from "../lib/Avo";
import { toggleConfirmClose, updateCloseStatus, } from "../features/navigation/navigationSlice";
import { useHistory, useLocation } from "react-router-dom";
import { CLOSE_REASONS } from "../lib/constants";
import { InsuranceProducts } from "../constants";
import { getMatchingPath } from "../utils/typeUtils";
import useAppDispatch from "./useAppDispatch";
import useAppSelector from "./useAppSelector";
import useCanShowMidFunnelAds from "../features/configuration/useCanShowMidFunnelAds";
import useCloseHandler from "./useCloseHandler";
import useRouteConfig from "./useRouteConfig";
var closingMidFunnelAdPhases = [
    PHASE.SELECT_INSURANCE_PRODUCT,
    PHASE.SELECT_AUTO_ISSUER,
    PHASE.HOME_SELECT_ISSUER,
    PHASE.HOME_ENTER_CREDENTIALS,
    PHASE.HOME_HAVE_LOGIN,
    PHASE.HOME_REMEMBER_LOGIN,
    PHASE.SAVVY_INTRO,
    PHASE.ENTER_CREDENTIALS,
    PHASE.HAVE_LOGIN,
    PHASE.REMEMBER_LOGIN,
    PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER,
    PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS,
    PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_RESIDENCE_STATUS,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_MAKE,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_YEAR,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_MODEL,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_TRIM,
    PHASE.UNLINKED_APPLICATION_AUTO_VEHICLES_EDIT_STATUS,
    PHASE.UNLINKED_APPLICATION_AUTO_DRIVERS,
    PHASE.UNLINKED_APPLICATION_AUTO_PAYMENT_PERIOD,
    PHASE.UNLINKED_APPLICATION_AUTO_PREMIUM,
    PHASE.UNLINKED_APPLICATION_AUTO_REVIEW,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_INTRO,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_POLICY_HOLDER,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PROPERTY_ADDRESS,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_EFFECTIVE_DATE,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_SQUARE_FOOTAGE,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_YEAR_BUILT,
    PHASE.UNLINKED_APPLICATION_HOMEOWNERS_PREMIUM,
];
export default function useCloseClickHandler() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _a = useAppSelector(function (state) { return state.configuration; }), showOnCloseAds = _a.showOnCloseAds, closeConfirmation = _a.closeConfirmation;
    var push = useHistory().push;
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var handleClose = useCloseHandler();
    var location = useLocation();
    var showConfirmClose = useAppSelector(function (state) { return state.navigation; }).showConfirmClose;
    var dispatch = useAppDispatch();
    var routeConfig = useRouteConfig();
    var homeOnlyApplicant = useAppSelector(function (state) { return state.applicant.insuranceProduct === InsuranceProducts.Home; });
    var validMidFunnelAdsPhase = Boolean(getMatchingPath(location.pathname, closingMidFunnelAdPhases));
    var handleCloseClick = React.useCallback(function (options) {
        if (options === void 0) { options = {}; }
        var reason = options.reason;
        var userClickedBackButton = reason === CLOSE_REASONS.CLICKED_BROWSER_BACK;
        var forceExitMethodTriggered = reason === CLOSE_REASONS.TRIGGERED_FORCED_EXIT_METHOD;
        var exitMethodTriggered = reason === CLOSE_REASONS.TRIGGERED_EXIT_METHOD;
        var closeStatus = options.status || (routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.status);
        var defaultCloseClick = function () {
            clickedCloseButton(__assign({}, commonAnalyticsProperties));
            handleClose(options);
        };
        var handleCloseConfirmation = function () {
            confirmCloseShown(__assign({}, commonAnalyticsProperties));
            return dispatch(toggleConfirmClose(true));
        };
        if (closeStatus) {
            dispatch(updateCloseStatus(closeStatus));
        }
        if (forceExitMethodTriggered) {
            return handleClose(options);
        }
        if (exitMethodTriggered) {
            if (!closeConfirmation) {
                return handleClose(options);
            }
            return handleCloseConfirmation();
        }
        if (userClickedBackButton) {
            return defaultCloseClick();
        }
        if (canShowMidFunnelAds && showOnCloseAds && validMidFunnelAdsPhase) {
            clickedCloseButton(__assign({}, commonAnalyticsProperties));
            return push(homeOnlyApplicant
                ? PHASE.HOME_MID_FUNNEL_ADS
                : PHASE.MID_FUNNEL_ADS_CLOSE);
        }
        if ((routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.confirmClose) &&
            closeConfirmation &&
            showConfirmClose === false) {
            return handleCloseConfirmation();
        }
        defaultCloseClick();
    }, [
        canShowMidFunnelAds,
        closeConfirmation,
        commonAnalyticsProperties,
        showConfirmClose,
        routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.confirmClose,
        routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.status,
        validMidFunnelAdsPhase,
        showOnCloseAds,
        push,
        handleClose,
        dispatch,
        homeOnlyApplicant,
    ]);
    return handleCloseClick;
}
